/**
 * 学习中心 FAQ 配置后台的 GraphQL 类型定义。
 * 与 api-server `DriverLearningCenterFaqTypes.kt` 保持一致。
 */

// 节点类型：1-分类，2-问答
export const FAQ_NODE_TYPE_CATEGORY = 1;
export const FAQ_NODE_TYPE_ARTICLE = 2;

export interface DriverLearningCenterFaqNode {
  id: string;
  nodeType: number;
  parentId: string | null;
  slug: string;
  titleZh: string | null;
  titleEn: string | null;
  titleEs: string | null;
  questionZh: string | null;
  questionEn: string | null;
  questionEs: string | null;
  answerZh: string | null;
  answerEn: string | null;
  answerEs: string | null;
  sortOrder: number;
  isEnabled: boolean;
  createdBy: string | null;
  createdByName: string | null;
  updatedBy: string | null;
  updatedByName: string | null;
  updatedAt: number | string | null;
  createdAt: number | string | null;
}

export interface DriverLearningCenterFaqPageResponse {
  content: DriverLearningCenterFaqNode[];
  pageNum: number;
  pageSize: number;
  total: number;
}

export interface DriverLearningCenterFaqPageRequest {
  pageNum: number;
  pageSize: number;
  nodeType?: number | null;
  parentId?: string | null;
  keyword?: string | null;
  isEnabled?: boolean | null;
}

export interface CreateFaqCategoryInput {
  slug: string;
  titleZh: string;
  titleEn: string;
  titleEs: string;
  sortOrder?: number | null;
}

export interface UpdateFaqCategoryInput {
  titleZh: string;
  titleEn: string;
  titleEs: string;
  sortOrder?: number | null;
}

export interface CreateFaqArticleInput {
  slug: string;
  parentId: string;
  questionZh: string;
  questionEn: string;
  questionEs: string;
  answerZh: string;
  answerEn: string;
  answerEs: string;
  sortOrder?: number | null;
}

export interface UpdateFaqArticleInput {
  parentId: string;
  questionZh: string;
  questionEn: string;
  questionEs: string;
  answerZh: string;
  answerEn: string;
  answerEs: string;
  sortOrder?: number | null;
}
